import { DemoSection } from '@/components/demo-section'
import { useI18n } from '@/lib/i18n'
import { useTRPC } from '@/lib/trpc'
import { useQuery } from '@tanstack/react-query'
import { Loader2 } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

export function ReviewPage() {
  const { gameId } = useParams<{ gameId: string }>()

  return <ReviewPageContent key={gameId ?? 'latest'} gameId={gameId} />
}

function ReviewPageContent({ gameId }: { gameId?: string }) {
  const { t } = useI18n()
  const trpc = useTRPC()
  const latestCompletedGameQuery = useQuery({
    ...trpc.reviewRouter.getLatestCompletedGame.queryOptions(),
    enabled: !gameId,
  })
  const [resolvedDefaultGameId, setResolvedDefaultGameId] = useState<
    string | null | undefined
  >(gameId)

  useEffect(() => {
    if (gameId || resolvedDefaultGameId !== undefined)
      return
    if (latestCompletedGameQuery.data !== undefined) {
      setResolvedDefaultGameId(latestCompletedGameQuery.data.gameId)
    }
    else if (latestCompletedGameQuery.isError) {
      setResolvedDefaultGameId(null)
    }
  }, [
    gameId,
    latestCompletedGameQuery.data,
    latestCompletedGameQuery.isError,
    resolvedDefaultGameId,
  ])

  if (!gameId && resolvedDefaultGameId === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background text-muted-foreground">
        <div className="text-center">
          <Loader2 className="mx-auto mb-4 size-10 animate-spin" />
          <p>{t('demo.loadingGame')}</p>
        </div>
      </div>
    )
  }

  const preferredGameId = gameId ?? resolvedDefaultGameId ?? undefined

  return (
    <div className="min-h-screen bg-background text-foreground">
      <main>
        <section id="review">
          <DemoSection
            initialGameId={preferredGameId}
            titleKey="nav.review"
            subtitle1Key="review.pageSubtitle"
            subtitle2Key={null}
          />
        </section>
      </main>
    </div>
  )
}
